import React, { createContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

const languages = {
    pt: {
        language: "pt",
        language_pt: "Português",
        language_en: "Inglês",
        language_es: "Espanhol",
        language_sigla: "PT-BR",
        language_active: "Português",
        language_pt_inverse: "Português",
        language_en_inverse: "English",
        language_es_inverse: "Español",
        menu_home: "Home",
        menu_news: "Notícias",
        menu_agenda: "Programação",
        menu_sp: "Cidade de São Paulo",
        menu_agenda_of: "Agenda de",
        menu_local: "Hoteis",
        menu_panel: "Palestrantes",
        menu_inscricao: "Inscreva-se",
        menu_sub_inscricao: "Inscrição",
        menu_sub_inscricao_imprensa: "Inscrição Imprensa",
        menu_imprensa: "Imprensa",
        menu_imprensa_press: "Press Release",
        menu_imprensa_material: "Notícias",
        menu_eventos: "Eventos",
        menu_edicao: "Edições Anteriores",
        menu_contato: "Contato",
        menu_events: "Eventos",
        mais_info: "Mais informações e participação em breve.",
        agenda_btn: "AGENDA PRELIMINAR",
        desenvolvido: "Desenvolvido por",
        site_name: "The 10th Frances Tustin International Conference",
        name: "Nome Completo",
        name_badge: "Nome para o crachá",
        email: "E-mail",
        password: "Crie sua Senha",
        just_password: "Senha",
        organization: "Organização",
        office: "Cargo",
        address: "Endereço",
        age: "Idade",
        race: "Raça",
        genre: "Gênero",
        phone: "Telefone",
        id: "Identidade",
        cpf: "CPF",
        state: "Estado onde reside",
        country: "País",
        disability: "Necessita de Acessibilidade?",
        food: "Restrição Alimentar",
        type: "Tipo de Participação",
        member: "Membros da FTMT",
        not_member: "Não membro",
        medium: "Veículo de comunicação",
        presencial: "Presencial",
        online: "Online",
        select: "Em relação aos painéis que teremos no dia 27/05, selecione abaixo quais você tem a intenção de participar",
        send: "ENVIAR",
        update: "ATUALIZAR",
        pre_inscricao: "PRÉ-INSCRIÇÃO",
        inscricao: "INSCRIÇÃO",
        error_input: "Preencha todos os campos obrigatórios!",
        error_type: "Preencha o Tipo de Participação!",
        success: "Inscrição realizada com sucesso!",
        error_email: "E-mail já está sendo usado por outra conta!",
        email_error: "INSCRIÇÃO NÃO EFETUADA por divergência de informações. Favor checar o e-mail digitado.",
        enter: "ACESSAR",
        error_login: "Erro ao fazer login!",
        error_input_email: "Preencha o campo E-mail!",
        error_input_senha: "Preencha o campo Senha!",
        error_incorrect: "E-mail ou senha incorretos!",
        login_title: "Acessar o Evento",
        select_watch: "Selecione o Evento que deseja assistir",
        error_select: "Selecione pelo menos um Evento!",
        error_found: "Código não encontrado!",
        code: "Código",
        hello: "Olá",
        logout: "Sair",
        back: "Voltar",
        yes: "Sim",
        no: "Não",
        not_comment: "Nenhum comentário encontrado.",
        write_comment: "Escreva seu comentário...",
        send_comment: "ENVIAR COMENTÁRIO",
        menu_watch: "Assista Aqui",
        click_here: "Clique Aqui",
        ended_online: "Inscrição apenas disponível para participação On-line",
        ended: "Inscrições presenciais encerradas",
        intend: "Você tem a intenção de participar",
        menu_day_26: "Dia 26/05",
        menu_day_27: "Dia 27/05",
        menu_imprensa_press_26: "Release - 26/05",
        menu_imprensa_press_27: "Release - 27/05",
        learn_more: "Saiba Mais",
        access_hotel: "Acessar Site do Hotel",
        card_full_name: "NOME COMPLETO",
        card_number: "Número do cartão",
        card_name: "Nome do cartão",
        card_valid: "Validade",
        card_month: "Mês",
        card_year: "Ano",
        card_yy: "AA",
        next: "Próximo",
        prev: "Anterior",
        abstract: "Resumo",
        abstracts: "Resumos",
        pre_conference: "Atividades pré-conferência na SBPSP",
        form_login: "Login",
        form_loging: "Acessando",
        form_loading: "Aguarde...",
        form_capture: "Processando pagamento...",
        form_midia: "Nome da Mídia",
        form_linkmidia: "Link da Mídia",
        form_zipcode: "CEP",
        form_address: "Endereço",
        form_number: "Número",
        form_complement: "Complemento",
        form_neighborhood: "Bairro",
        form_city: "Cidade",
        form_state: "Estado",
    },
    es: {
        language: "es",
        language_pt: "Portugués",
        language_en: "Inglés",
        language_es: "Español",
        language_sigla: "ES",
        language_active: "Español",
        language_pt_inverse: "Português",
        language_en_inverse: "English",
        language_es_inverse: "Español",
        menu_home: "Inicio",
        menu_news: "Noticias",
        menu_agenda: "Programación",
        menu_sp: "Ciudad de São Paulo",
        menu_agenda_of: "Agenda de",
        menu_local: "Hoteles",
        menu_panel: "Ponentes",
        menu_inscricao: "Inscríbete",
        menu_sub_inscricao: "Inscripción",
        menu_sub_inscricao_imprensa: "Inscripción Prensa",
        menu_imprensa: "Prensa",
        menu_imprensa_press: "Comunicado de Prensa",
        menu_imprensa_material: "Noticias",
        menu_eventos: "Eventos",
        menu_edicao: "Ediciones Anteriores",
        menu_contato: "Contacto",
        menu_events: "Eventos",
        mais_info: "Más información y participación próximamente.",
        agenda_btn: "AGENDA PRELIMINAR",
        desenvolvido: "Desarrollado por",
        site_name: "The 10th Frances Tustin International Conference",
        name: "Nombre Completo",
        name_badge: "Nombre para la credencial",
        email: "Correo electrónico",
        password: "Crea tu contraseña",
        just_password: "Contraseña",
        organization: "Organización",
        office: "Cargo",
        address: "Dirección",
        age: "Edad",
        race: "Raza",
        genre: "Género",
        phone: "Teléfono",
        id: "Documento de identidad",
        cpf: "CPF",
        state: "Estado de residencia",
        country: "País",
        disability: "¿Necesita accesibilidad?",
        food: "Restricción alimentaria",
        type: "Tipo de participación",
        member: "Miembros de la FTMT",
        not_member: "No miembro",
        medium: "Medio de comunicación",
        presencial: "Presencial",
        online: "En línea",
        select: "Con respecto a los paneles que tendremos el día 27/05, seleccione a continuación cuáles tiene intención de participar",
        send: "ENVIAR",
        update: "ACTUALIZAR",
        pre_inscricao: "PREINSCRIPCIÓN",
        inscricao: "INSCRIPCIÓN",
        error_input: "¡Complete todos los campos obligatorios!",
        error_type: "¡Complete el tipo de participación!",
        success: "¡Inscripción realizada con éxito!",
        error_email: "¡El correo electrónico ya está siendo usado por otra cuenta!",
        email_error: "INSCRIPCIÓN NO REALIZADA por divergencia de información. Por favor, verifique el correo electrónico ingresado.",
        enter: "ACCEDER",
        error_login: "¡Error al iniciar sesión!",
        error_input_email: "¡Complete el campo Correo electrónico!",
        error_input_senha: "¡Complete el campo Contraseña!",
        error_incorrect: "¡Correo electrónico o contraseña incorrectos!",
        login_title: "Acceder al Evento",
        select_watch: "Seleccione el evento que desea ver",
        error_select: "¡Seleccione al menos un evento!",
        error_found: "¡Código no encontrado!",
        code: "Código",
        hello: "Hola",
        logout: "Salir",
        back: "Volver",
        yes: "Sí",
        no: "No",
        not_comment: "No se encontraron comentarios.",
        write_comment: "Escriba su comentario...",
        send_comment: "ENVIAR COMENTARIO",
        menu_watch: "Ver aquí",
        click_here: "Haga clic aquí",
        ended_online: "Inscripción disponible solo para participación en línea",
        ended: "Inscripciones presenciales cerradas",
        intend: "¿Tiene la intención de participar?",
        menu_day_26: "Día 26/05",
        menu_day_27: "Día 27/05",
        menu_imprensa_press_26: "Comunicado - 26/05",
        menu_imprensa_press_27: "Comunicado - 27/05",
        learn_more: "Más información",
        access_hotel: "Acceder al sitio del hotel",
        card_full_name: "NOMBRE COMPLETO",
        card_number: "Número de la tarjeta",
        card_name: "Nombre en la tarjeta",
        card_valid: "Validez",
        card_month: "Mes",
        card_year: "Año",
        card_yy: "AA",
        next: "Siguiente",
        prev: "Anterior",
        abstract: "Resumen",
        abstracts: "Resúmenes",
        pre_conference: "Actividades previas a la conferencia en la SBPSP",
        form_login: "Iniciar sesión",
        form_loging: "Iniciando sesión",
        form_loading: "Cargando...",
        form_capture: "Procesando pago...",
        form_midia: "Medios",
        form_linkmidia: "Enlace de medios",
        form_zipcode: "Código postal",
        form_address: "Dirección",
        form_number: "Número",
        form_complement: "Complemento",
        form_neighborhood: "Barrio",
        form_city: "Ciudad",
        form_state: "Estado",
    },
    en: {
        language: "en",
        language_pt: "Portuguese",
        language_en: "English",
        language_es: "Spanish",
        language_sigla: "EN",
        language_active: "English",
        language_pt_inverse: "Português",
        language_en_inverse: "English",
        language_es_inverse: "Español",
        menu_home: "Home",
        menu_news: "News",
        menu_agenda: "Program",
        menu_sp: "São Paulo City",
        menu_agenda_of: "Calendar of",
        menu_local: "Hotels",
        menu_panel: "Speakers",
        menu_inscricao: "Registration",
        menu_sub_inscricao: "Registration",
        menu_sub_inscricao_imprensa: "Press Registration",
        menu_imprensa: "Press",
        menu_imprensa_press: "Press Release",
        menu_imprensa_material: "News",
        menu_eventos: "Events",
        menu_edicao: "Previous Editions",
        menu_contato: "Contact",
        menu_events: "Events",
        mais_info: "More info and participation soon.",
        agenda_btn: "PRELIMINARY AGENDA",
        desenvolvido: "Developed by",
        site_name: "The 10th Frances Tustin International Conference",
        name: "Full Name",
        name_badge: "Name on badge",
        email: "Email",
        password: "Create your Password",
        just_password: "Password",
        organization: "Organization",
        office: "Office",
        address: "Address",
        age: "Age",
        race: "Race",
        genre: "Gender",
        phone: "Phone",
        id: "ID/PASSPORT",
        cpf: "CPF",
        state: "State where you reside",
        country: "Country",
        disability: "Specific Need?",
        food: "Food Restriction",
        type: "Participant Type",
        member: "FTMT Members",
        not_member: "Not a member",
        medium: "Communication media",
        presencial: "In person",
        online: "Online",
        select: "Regarding the panels scheduled for May 27th, select below the ones you wish to attend",
        send: "SEND",
        update: "UPDATE",
        pre_inscricao: "PRE-REGISTRATION",
        inscricao: "ENROLLMENT",
        error_input: "Please fill in all required fields!",
        error_type: "Fill in the type of participation!",
        success: "Registration successful!",
        error_email: "Email is already being used by another account!",
        email_error: "REGISTRATION NOT COMPLETED due to conflicting information. Please check the email address entered.",
        enter: "ACCESS",
        error_login: "Error when logging in!",
        error_input_email: "Fill in the email field!",
        error_input_senha: "Fill in the password field!",
        error_incorrect: "Incorrect email or password!",
        login_title: "Access the Event",
        select_watch: "Select the event you want to watch",
        error_select: "Select at least one Event!",
        error_found: "Code not found!",
        code: "Code",
        hello: "Hello",
        logout: "Logout",
        back: "Back",
        yes: "Yes",
        no: "No",
        not_comment: "No comments found.",
        write_comment: "Write your comment...",
        send_comment: "SEND COMMENT",
        menu_watch: "Watch Here",
        click_here: "Click Here",
        ended_online: "Registration only available for Online participation",
        ended: "In-person registrations closed",
        intend: "Do you intend to participate",
        menu_day_26: "May 26",
        menu_day_27: "May 27",
        menu_imprensa_press_26: "Release - May 26",
        menu_imprensa_press_27: "Release - May 27",
        learn_more: "Learn More",
        access_hotel: "Visit Hotel Website",
        card_full_name: "FULL NAME",
        card_number: "Card Number",
        card_name: "Card Name",
        card_valid: "Expiration",
        card_month: "Month",
        card_year: "Year",
        card_yy: "YY",
        next: "Next",
        prev: "Previous",
        abstract: "Abstract",
        abstracts: "Abstracts",
        pre_conference: "Pre conference activities at SBPSP",
        form_login: "Login",
        form_loging: "Logging in",
        form_loading: "Loading...",
        form_capture: "Processing payment...",
        form_midia: "Media",
        form_linkmidia: "Media Link",
        form_zipcode: "Zipcode",
        form_address: "Address",
        form_number: "Number",
        form_complement: "Complement",
        form_neighborhood: "Neighborhood",
        form_city: "City",
        form_state: "State",
    }
}

export const LanguageProvider = ({ children }) => {
    
    const [language, setLanguage] = useState({});

    async function loadStorage() {
        const storageLanguage = localStorage.getItem('language');
        if (!storageLanguage) {
            setLanguageStore('pt');
        }else{
            setLanguageStore(storageLanguage);
        }
    }

    async function setStorage(lang) {
        localStorage.setItem('language', lang);
    }

    function setLanguageStore(lang){
        if(lang==="pt" || lang==="PT"){
            setLanguage(languages.pt);
            setStorage("pt");
        }else if(lang==="en" || lang==="EN"){
            setLanguage(languages.en);
            setStorage("en");
        }else{
            setLanguage(languages.es);
            setStorage("es");
        }
        /* if(lang==="pt" || lang==="PT"){
            setLanguage(languages.pt);
            setStorage("pt");
        }else{
            setLanguage(languages.en);
            setStorage("en");
        } */
    }

    useEffect(() => {
        loadStorage();
    }, [language]);

    return (
        <LanguageContext.Provider value={{ language, setLanguage, setLanguageStore }} >
            {children}
        </LanguageContext.Provider>
    )

}

export default LanguageContext;